module.exports = __webpack_public_path__ + "static/media/ic_check.7b40b252.svg";